import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LrwSessionTableState, LrwSessionsQueryFilters } from './types';
import { getDefaultLrwSessionsQueryFilters } from './defaultFilters';

type LrwSessionState = LrwSessionTableState & { filters: LrwSessionsQueryFilters };

const initialState = (): LrwSessionState => ({
  pageIndex: 0,
  pageSize: 25,
  sortBy: [{ id: 'date', desc: true }],
  filters: getDefaultLrwSessionsQueryFilters(),
});

export const { actions, reducer } = createSlice({
  name: 'lrw-session',
  initialState,
  reducers: {
    updateTableState: (state, action: PayloadAction<LrwSessionTableState>) => {
      state.pageIndex = action.payload.pageIndex;
      state.pageSize = action.payload.pageSize;
      state.sortBy = action.payload.sortBy;
    },
    applyFilters: (state, action: PayloadAction<LrwSessionsQueryFilters>) => {
      state.filters = action.payload;
      state.pageIndex = 0;
    },
  },
});
